import {Component, EventEmitter, inject, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';

import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faChevronRight} from '@fortawesome/pro-solid-svg-icons';
import {faSpinnerThird} from '@fortawesome/pro-duotone-svg-icons';

import {BicButtonComponent} from '@buildinginformationcloud/bic-ui-components';
import {ProjectFile, ProjectFileControllerService} from '../../../../api';
import {FilesComponent} from '../../../files/files.component';
import {StepCommunicationService} from '../step-communication.service';
import {addMissingAncestorFolders} from '../../../../services/files/file-tree.utils';

@Component({
  selector: 'my-checks-step-file-select',
  standalone: true,
  imports: [BicButtonComponent, FontAwesomeModule, FilesComponent],
  templateUrl: './step-file-select.component.html',
  styleUrls: ['./step-file-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {class: 'flex flex-col h-full w-full'},
})
export class StepFileSelectComponent implements OnInit {
  @Input() config: any;
  @Input() projectId = 0;
  @Output() selected = new EventEmitter<any>();
  @Output() cancelled = new EventEmitter<void>();
  files: ProjectFile[] = [];
  selectedFiles: ProjectFile[] = [];
  loading = true;
  confirming = false;
  protected readonly faChevronRight = faChevronRight;
  protected readonly faSpinnerThird = faSpinnerThird;
  private fileService = inject(ProjectFileControllerService);
  private stepComm = inject(StepCommunicationService, {optional: true});

  ngOnInit() {
    this.loadFiles();
  }

  loadFiles(): void {
    const fileTypes: string[] = this.config?.fileTypes ?? ['IFC'];
    this.loading = true;

    this.fileService.getFiles(this.projectId).subscribe({
      next: files => {
        this.files = files.filter(f =>
          fileTypes.includes(f.fileType!) && f.fileStatus !== 'ERROR'
        );

        // Add ALL missing ancestor folders (not just the immediate parent) so app-files can display the tree
        this.files.forEach(file => addMissingAncestorFolders(this.files, files, file));
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  confirm(): void {
    if (this.selectedFiles.length > 0) {
      this.confirming = true;
      const data = {
        project_files: this.selectedFiles.map(f => ({
          id: f.id,
          name: f.name,
          link: f.link,
          fileType: f.fileType,
          size: f.size,
        })),
      };
      this.selected.emit(data);
      this.stepComm?.submit(data);
    }
  }
}
